import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PoliciesVerticalSummaryCard from '../PoliciesVerticalSummaryCard';
import Spinner from 'shared/lib/components/Spinner';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import classnames from 'classnames';
import VERTICALS from 'shared/lib/constants/verticals';
import * as analytics from 'shared/lib/analytics';
import './PoliciesAllVerticalsView.css';
import policyPlaceholderIcon from './policy-placeholder-icon.png';
import ProductDropdownMenu from '../ProductDropdownMenu';

const propTypes = {
  getPoliciesSummary: PropTypes.func,
  mostRecentPoliciesByVertical: PropTypes.object,
  policiesTotalsByVertical: PropTypes.object,
  isFetchingPolicies: PropTypes.bool,
};

const defaultProps = {
  mostRecentPoliciesByVertical: {},
  policiesTotalsByVertical: {},
  isFetchingPolicies: false,
};

class PoliciesAllVerticalsView extends PureComponent {
  state = {
    isMenuOpen: false,
  };

  componentDidMount() {
    document.title = 'Your Policies | Sure';
    this.props.getPoliciesSummary();
    analytics.page('Policy Management - Your Policies');
  }

  handleToggleMenu = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
  };

  get summaryCardsNodes() {
    if (isEmpty(this.props.policiesTotalsByVertical)) {
      return (
        <div className="PoliciesAllVerticalsView-zero-policy-container">
          <div className="PoliciesAllVerticalsView-zero-policy-wrapper">
            <img
              className="PoliciesAllVerticalsView-zero-policy-img"
              src={policyPlaceholderIcon}
              alt="Policy placeholder icon"
            />
            <div className="PoliciesAllVerticalsView-zero-policy-copy">
              <h2 className="PoliciesAllVerticalsView-zero-policy-heading">
                You have no policies
              </h2>
              <p className="PoliciesAllVerticalsView-zero-policy-cta">
                Click on Get Protection to find the right policy for you
              </p>
            </div>
            <div
              className={classnames(
                'PoliciesAllVerticalsView-zero-policy-dropdown',
                { 'is-open': this.state.isMenuOpen }
              )}
              onClick={this.handleToggleMenu}
            >
              <div className="PoliciesAllVerticalsView-zero-policy-btn">
                Get Protection
              </div>
              <ProductDropdownMenu
                className="PoliciesAllVerticalsView-zero-policy-dropdown-menu"
                onHideMenu={this.props.onHideMenu}
              />
            </div>
          </div>
        </div>
      );
    }
    return map(
      this.props.mostRecentPoliciesByVertical,
      (recentPolicies, verticalCode) => (
        <PoliciesVerticalSummaryCard
          key={verticalCode}
          icon={VERTICALS[verticalCode].icon}
          title={`${VERTICALS[verticalCode].title} Policies`}
          totalPolicies={this.props.policiesTotalsByVertical[verticalCode]}
          recentPolicies={recentPolicies}
          verticalCode={verticalCode}
        />
      )
    );
  }

  render() {
    return (
      <div className="PoliciesAllVerticalsView Container">
        <h1 className="PoliciesAllVerticalsView-heading">
          Your policies
          {this.props.isFetchingPolicies && <Spinner />}
        </h1>
        {this.summaryCardsNodes}
      </div>
    );
  }
}

PoliciesAllVerticalsView.propTypes = propTypes;
PoliciesAllVerticalsView.defaultProps = defaultProps;

export default PoliciesAllVerticalsView;
